import { useState } from "react";
import * as queryString from 'query-string'
import { RESULTS_PAGE_URL } from "../constants.js";

const FindAnAceProLocationSearch = ({ countries, provinces }) => {
    const queryStringParameters = queryString.parse(location.search);
    const [country, setCountry] = useState(queryStringParameters.country || "US")
    const [province, setProvince] = useState(queryStringParameters.province || "Alberta")
    const [radius, setRadius] = useState(queryStringParameters.radius || 10)
    const [zipCode, setZipCode] = useState(queryStringParameters.zipCode || "")
    const rad = [5, 10, 15, 20, 25, 50, 100, 150]

    const handleEnterPressedForSearch = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            searchByLocation();
        }
    }

    const handleSearchClick = (event) => {
        event.preventDefault();
        searchByLocation();
    }


    const handleZipCodeChange = (event) => {
        let value = event.target.value;
        value = value.replace(/\D/g, '');
        setZipCode(value)
    }

    const searchByLocation = () => {
        const params = {
            country: country,
            radius: radius,
            zipCode: undefined,
            province: undefined
        };

        if (country === 'US') {
            params.zipCode = zipCode;
        }

        if (country === 'CA') {
            params.province = province;
        }

        window.location.replace(RESULTS_PAGE_URL + "?" + queryString.stringify(params));
    }


    const btnIcon = 'Find An ACE Pro<span class="icon-wrap"><svg aria-hidden="true" class="icon icon--angle-right-bold icon--white"><use xlink:href="#icon-angle-right-bold"></use></svg>';

    return (
        <div>
            <select name="country" className="fap-search__country no-selectric" onChange={(e) => setCountry(e.target.value)} value={country} onKeyPress={handleEnterPressedForSearch}>
                {countries.map((c) => <option key={c.id} value={c.abbreviation}>{c.name}</option>)}
            </select>
            {country === 'US' && (
                <>
                    <span className="fap-search__radius-label">Search radius (miles)</span>
                    <select
                        name="radius"
                        onChange={(e) => setRadius(e.target.value)}
                        className="fap-search__radius no-selectric"
                        value={radius}
                        onKeyPress={handleEnterPressedForSearch}
                    >
                        {rad.map((r, i) => <option key={i} value={r}>{r}</option>)}
                    </select>
                    <input
                        type="text"
                        className="fap-search__zip fap-search__input"
                        name="zipCode"
                        placeholder="Zip"
                        maxLength={5}
                        value={zipCode}
                        onChange={handleZipCodeChange}
                        onKeyPress={handleEnterPressedForSearch} />
                </>
            )}
            {country === 'CA' && (
                <>
                    <select
                        name="province"
                        onChange={(e) => setProvince(e.target.value)}
                        className="fap-search__province no-selectric"
                        value={province}
                        onKeyPress={handleEnterPressedForSearch}
                    >
                        {provinces.map(p => <option key={p.id} value={p.abbreviation}>{p.name}</option>)}
                    </select>
                </>
            )}
            <button id="exam-area-search" className="ace-btn-primary fap-search__submit" onClick={handleSearchClick} onKeyPress={handleEnterPressedForSearch} dangerouslySetInnerHTML={{ __html: btnIcon }}></button>
        </div>
    )
}

export default FindAnAceProLocationSearch
